import React from "react"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { productUnitsSymbol } from "constant"
import { thousandSeparator } from "utils"
import classes from "./CheckoutOrderCombo.module.scss"

const CheckoutOrderCombo = props => {
  const {
    orderHasCoupons,
    orderCombo,
    doesOrderHasOneItem,
    selectedOrderCombos,
    setSelectedOrdersCombos
  } = props

  const [t, i18n] = useTranslation()

  const orderForEditDetails =
    useSelector(state =>
      state.orderForEditDetails
    )

  const isOnline =
    useSelector(state => !state.internetStatus.forceOffline) &&
    !orderForEditDetails?.offlineOrderId

  const isOrderComboPaid = () => (
    orderCombo.items.every(comboItem =>
      orderForEditDetails?.subPaymentItems?.[comboItem.orderItemId]?.paymentStatus === "paid"
    )
  )

  const handleSelect = () => {
    if (!isSelectable) return

    setSelectedOrdersCombos(prev =>
      isSelected ?
        prev.filter(oc =>
          oc.groupNumber !== orderCombo.groupNumber
        ) :
        [...prev, orderCombo]
    )
  }

  const isPaid = isOrderComboPaid()

  const isSelected =
    selectedOrderCombos.some(selectedOrderCombo =>
      selectedOrderCombo.groupNumber === orderCombo.groupNumber
    )

  const isSelectable =
    isOnline &&
    !isPaid &&
    !orderHasCoupons &&
    !doesOrderHasOneItem

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      onClick={handleSelect}
      className={clsx(
        classes["card"],
        isSelectable && classes["select"],
        isSelected && classes["active"]
      )}
    >
      <div className={classes["title"]}>
        {orderCombo.name}
      </div>

      <div className={classes["card-content"]}>
        <div className={classes["row"]}>
          <div className={classes["details"]}>
            {orderCombo.items.map((comboItem, ciIndex) =>
              <div
                key={ciIndex}
                className={classes["comboItem"]}
              >
                <div className={classes["name-container"]}>
                  <span
                    className={clsx(
                      classes["name"],
                      isLtr && classes["name-ltr"]
                    )}
                  >
                    {comboItem.foodName}
                  </span>
                  <span className={classes["quantity"]}>
                    <MdClose size={18} />
                    <b>{comboItem.quantity}{t(productUnitsSymbol[comboItem.unit])}</b>
                  </span>
                </div>
                {
                  !comboItem.isSimple &&
                  <div className={classes["comboItemOptionName"]}>
                    ({comboItem.optionName})
                  </div>
                }
              </div>
            )}
          </div>
        </div>

        <div className={classes["right"]}>
          <div className={classes["price"]}>
            {thousandSeparator(orderCombo.comboSetSalePrice)}
          </div>
          {
            isPaid &&
            <div
              className={clsx(
                classes["paid"],
                isLtr && classes["paid-ltr"]
              )}
            >
              پرداخت شده
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default React.memo(CheckoutOrderCombo)